/** Same shape check the API applies before sending a login e-mail. */
export function isEmailAddress(value: string | null | undefined): boolean {
  const s = (value ?? "").trim();
  return s.length > 0 && s.length <= 150 && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(s);
}
